define('webshopCategoriesDetailBodySiteAccessView',[
  'app',
  'module',
  'backbone',
  'marionette',
  'underscore',
  'modalsAlertView',
  'template!webshopCategoriesDetailBodySiteAccessView'
], function (
    App,
    Module,
    Backbone,
    Marionette,
    _,
    AlertView,
    Tpl
) {
  'use strict';

  Module.exports = Marionette.ItemView.extend({
    template: Tpl,
    className: 'webshop-categories-detail-body-site-access-view',

    ui: {
      checkbox: 'input.site-disabled-toggle'
    },

    events: {
      'change @ui.checkbox': 'onToggle'
    },

    serializeData: function () {
      var disabled = this.model.getDisabledSites();
      var sites = [];

      _.each(this.options.webshopConfig.attributes, function (site) {
        if (!site || !site.id)
          return;

        sites.push({
          id: site.id,
          language: site.language || '',
          region: site.region || '',
          domain: site.primaryDomain || site.domain || '',
          disabled: _.contains(disabled, site.id)
        });
      });

      return {
        sites: sites,
        hasSites: sites.length > 0
      };
    },

    onToggle: function () {
      var selected = [];
      this.ui.checkbox.each(function () {
        if (this.checked)
          selected.push(this.value);
      });

      this.ui.checkbox.prop('disabled', true);

      this.model.setDisabledSites(selected).done(_.bind(function () {
        this.ui.checkbox.prop('disabled', false);
      }, this)).fail(_.bind(function (err) {
        this.ui.checkbox.prop('disabled', false);
        var message = (err && err.message) ? err.message : _.i18n('webshop.errors.unknown');
        AlertView.prototype.open('', message);
        this.render();
      }, this));
    }
  });
});

